import { TrendingUp, TrendingDown, IndianRupee, CreditCard, Building, Coins, Calculator } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import { FinancialDataMatric, MetricData } from "../types/FinancialInterface";

interface MetricsOverviewProps {
  financialData: FinancialDataMatric[];
}

export const MetricsOverview = ({ financialData }: MetricsOverviewProps) => {

  // Get last 2 years for comparison
  const sortedData = financialData.sort((a, b) => new Date(b.year).getTime() - new Date(a.year).getTime());
  const currentYear = sortedData[0];
  const previousYear = sortedData[1] ?? null;

  // Helper function to calculate percentage change
  const calculateChange = (current: number, previous: number): { change: string; trend: "up" | "down" } => {
    if (!previous || previous === 0) {
      return { change: "0%", trend: "up" };
    }
    const percentChange = ((current - previous) / previous) * 100;
    return {
      change: `${Math.abs(percentChange).toFixed(0)}%`,
      trend: percentChange >= 0 ? "up" : "down"
    };
  };


  // Define metrics with dynamic calculations
  const metrics: MetricData[] = [
    {
      title: "Revenue",
          value:  '₹'+String(currentYear?.netRevenue ?? currentYear?.net_revenue) + ' Cr' ,
        ...calculateChange(currentYear?.netRevenue ?? currentYear?.net_revenue ?? 0, previousYear?.netRevenue ?? previousYear?.net_revenue ?? 0),
        icon: IndianRupee,
      },

    {
      title: "PAT",
      value:  '₹'+String(currentYear?.pat)  + ' Cr',
      ...calculateChange(currentYear?.pat ?? 0, previousYear?.pat ?? 0),
      icon: Calculator,
    },
    // {
    //   title: "Expenses", 
    //   value: formatCurrency(currentExpenses),
    //   ...calculateChange(currentExpenses, previousExpenses),
    //   icon: Receipt,
    // },
    {
        title: "Tangible Net Worth",
        value: '₹'+String(currentYear?.tangibleNetWorth ?? currentYear?.tangible_net_worth ?? 0)+ ' Cr',
        ...calculateChange(currentYear?.tangibleNetWorth ?? currentYear?.tangible_net_worth ?? 0, previousYear?.tangibleNetWorth ?? previousYear?.tangible_net_worth ?? 0),
        icon: Coins,
      },
    // {
    //   title: "EBITDA",
    //   value: formatCurrency(currentYear.ebitda),
    //   ...calculateChange(currentYear.ebitda, previousYear.ebitda),
    //   icon: BarChart3,
    // },
    // {
    //   title: "PAT",
    //   value: formatCurrency(currentYear.pat),
    //   ...calculateChange(currentYear.pat, previousYear.pat),
    //   icon: Calculator,
    // },
    {
      title: "Debt",
      value: '₹'+String(currentYear?.totalDebt ?? currentYear?.total_debt ?? 0)+ ' Cr',
      ...calculateChange(currentYear?.totalDebt ?? currentYear?.total_debt ?? 0, previousYear?.totalDebt ?? previousYear?.total_debt ?? 0),
      icon: CreditCard,
    },
    {
      title: "Tangible Asset",
      value: '₹'+String(currentYear?.tangibleAssets ?? currentYear?.tangible_assets ?? 0)+ ' Cr',
      ...calculateChange(currentYear?.tangibleAssets ?? currentYear?.tangible_assets ?? 0, previousYear?.tangibleAssets ?? previousYear?.tangible_assets ?? 0),
      icon: Building,
    },
   
  ];

  return (
    <Card className="w-full">
      <CardContent className="p-6">
        <div className="grid grid-cols-5 gap-4">
          {metrics.map((metric) => {
            const Icon = metric.icon;
            return (
              <div 
                key={metric.title} 
                className="flex items-center gap-2 p-3 rounded-lg border transition-all duration-200 hover:shadow-md hover:scale-105 bg-gradient-to-br from-[#5D98A1]/5 to-[#9CC5CB]/5 hover:from-[#5D98A1]/10 hover:to-[#9CC5CB]/10"
              >
                <div className="w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300 bg-gradient-to-br from-[#5D98A1]/20 to-[#9CC5CB]/20 shadow-lg shadow-[#5D98A1]/25">
                  <Icon className="h-5 w-5 text-[#5D98A1] drop-shadow-sm" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs text-muted-foreground truncate">{metric.title}</p>
                  <p className="text-sm font-bold truncate">{metric.value}</p>
                  <div className="flex items-center gap-1 text-xs">
                    {metric.trend === 'up' ? (
                      <TrendingUp className="h-3 w-3 text-green-600 flex-shrink-0" />
                    ) : (
                      <TrendingDown className="h-3 w-3 text-red-600 flex-shrink-0" />
                    )}
                    <span className={`${metric.trend === 'up' ? 'text-green-600' : 'text-red-600'} whitespace-nowrap`}>
                      {metric.change}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};